<div class="user-in-group-container">
    <ng-container *ngIf="startRender;then groupfield;else fake"></ng-container>
    <app-search-field [form]="form" placeholder="利用者検索"></app-search-field>
    <div class="horizontal-line-1"></div>
    <div class="btn-group">
        <button mat-stroked-button color="primary" (click)="listControl(false,true)">全選択</button>
        <button mat-stroked-button color="primary" (click)="listControl(true,false)">全解除</button>
    </div>
    <div class="horizontal-line-1"></div>
    <ng-container *ngIf="startRender">
        <ng-container *ngIf="filtered$ | async as userList">
            <ul *ngIf="userList.length > 0; else none" class="user-list">
                <li *ngFor="let user of userList">
                    <app-user-item [user]="user" (click)="onChange(user)" [multiSeletect]="true" [selected]="checkSelect(user.daicd)"></app-user-item>
                </li>
            </ul>
            <ng-template #none>
                <p class="list-none">表示するデータがありません</p>
            </ng-template>
        </ng-container>
    </ng-container>
</div>

<ng-template #groupfield>
    <app-search-group-field [form]="form" placeholder="グループ選択" [data]="userInGroupRender" [indicatorString]="'グループ'"
        [treeControl]="treeControl" [treeFlattener]="treeFlattener"
        (selectedNode)="filterByGroup($event)"></app-search-group-field>
    <div class="horizontal-line-1"></div>
</ng-template>

<ng-template #fake>
    <div class="search">
        <input matInput [placeholder]="'グループ選択'" disabled [ngStyle]="{'font-size': '15px'}" />
    </div>
</ng-template>